import { API_STATUS } from 'core-lib/constants/network';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { storeHomePage } from '../services/home/getHomepage';
import { updateMlExclusivepage, updateStoreHomepage } from '../store/action';
import { HomeDataType } from '../types/home';
import useParkplusStoreV2 from './useParkplusStoreV2';

const useStoreHome = () => {
  // declarations
  const dispatch = useDispatch();
  const router = useRouter();

  const { storeHomepage, mlExclusivepage } = useParkplusStoreV2();

  const activeTab = router?.query?.active_tab ? +router.query.active_tab : 0;

  const data = activeTab === 0 ? storeHomepage : mlExclusivepage;

  const fetchHomePage = async (categoryId = "STORE_HOMEPAGE", page = 1, limit = 5) => {
    // setApiStatus(API_STATUS.in_progress);
    let payload: HomeDataType = {
      ...data,
      apiStatus: API_STATUS.in_progress,
    };
    if (categoryId === "STORE_HOMEPAGE") {
      dispatch(updateStoreHomepage(payload));
    } else {
      dispatch(updateMlExclusivepage(payload));
    }
    const response = await storeHomePage(categoryId, page, limit);
    if (response) {
      const newData = JSON.parse(JSON.stringify(data));

      newData.data = [...(newData?.data ?? []), ...response?.data];
      newData.page = response.page;
      newData.hasMore = response.hasMore;
      payload = {
        ...newData,
        apiStatus: API_STATUS.success,
      };
      if (response?.categoryId === "STORE_HOMEPAGE") {
        dispatch(updateStoreHomepage(payload));
      } else {
        dispatch(updateMlExclusivepage(payload));
      }
      return newData;
    }
  };

  return {
    fetchHomePage,
  };
};

export default useStoreHome;
